/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AdminRefundAccountResponseDto } from '../models/admin-refund-account-response-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { orderControllerCancel } from '../fn/order/order-controller-cancel';
import { OrderControllerCancel$Params } from '../fn/order/order-controller-cancel';
import { orderControllerCompleteRefund } from '../fn/order/order-controller-complete-refund';
import { OrderControllerCompleteRefund$Params } from '../fn/order/order-controller-complete-refund';
import { orderControllerConfirmDeposit } from '../fn/order/order-controller-confirm-deposit';
import { OrderControllerConfirmDeposit$Params } from '../fn/order/order-controller-confirm-deposit';
import { orderControllerCreate } from '../fn/order/order-controller-create';
import { OrderControllerCreate$Params } from '../fn/order/order-controller-create';
import { orderControllerFindById } from '../fn/order/order-controller-find-by-id';
import { OrderControllerFindById$Params } from '../fn/order/order-controller-find-by-id';
import { orderControllerGetMyStats } from '../fn/order/order-controller-get-my-stats';
import { OrderControllerGetMyStats$Params } from '../fn/order/order-controller-get-my-stats';
import { orderControllerGetRefundAccountByOrder } from '../fn/order/order-controller-get-refund-account-by-order';
import { OrderControllerGetRefundAccountByOrder$Params } from '../fn/order/order-controller-get-refund-account-by-order';
import { orderControllerGetStats } from '../fn/order/order-controller-get-stats';
import { OrderControllerGetStats$Params } from '../fn/order/order-controller-get-stats';
import { orderControllerRequestRefund } from '../fn/order/order-controller-request-refund';
import { OrderControllerRequestRefund$Params } from '../fn/order/order-controller-request-refund';
import { orderControllerSearch } from '../fn/order/order-controller-search';
import { OrderControllerSearch$Params } from '../fn/order/order-controller-search';
import { orderControllerSearchMyOrders } from '../fn/order/order-controller-search-my-orders';
import { OrderControllerSearchMyOrders$Params } from '../fn/order/order-controller-search-my-orders';
import { orderControllerUpdateMemo } from '../fn/order/order-controller-update-memo';
import { OrderControllerUpdateMemo$Params } from '../fn/order/order-controller-update-memo';
import { OrderDto } from '../models/order-dto';
import { OrderMyStatsDto } from '../models/order-my-stats-dto';

@Injectable({ providedIn: 'root' })
export class OrderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `orderControllerSearch()` */
  static readonly OrderControllerSearchPath = '/api/orders';

  /**
   * 주문 목록 조회 (관리자용).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerSearch$Response(params: OrderControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    const obs = orderControllerSearch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 주문 목록 조회 (관리자용).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerSearch(params: OrderControllerSearch$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    const resp = this.orderControllerSearch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `orderControllerCreate()` */
  static readonly OrderControllerCreatePath = '/api/orders';

  /**
   * 주문 신청.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerCreate$Response(params: OrderControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderDto>> {
    const obs = orderControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 주문 신청.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerCreate(params: OrderControllerCreate$Params, context?: HttpContext): Observable<OrderDto> {
    const resp = this.orderControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrderDto>): OrderDto => r.body)
    );
  }

  /** Path part for operation `orderControllerSearchMyOrders()` */
  static readonly OrderControllerSearchMyOrdersPath = '/api/orders/my';

  /**
   * 내 주문 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerSearchMyOrders()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerSearchMyOrders$Response(params: OrderControllerSearchMyOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    const obs = orderControllerSearchMyOrders(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 내 주문 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerSearchMyOrders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerSearchMyOrders(params: OrderControllerSearchMyOrders$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    const resp = this.orderControllerSearchMyOrders$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `orderControllerGetStats()` */
  static readonly OrderControllerGetStatsPath = '/api/orders/stats';

  /**
   * 주문 통계 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerGetStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerGetStats$Response(params?: OrderControllerGetStats$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = orderControllerGetStats(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 주문 통계 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerGetStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerGetStats(params?: OrderControllerGetStats$Params, context?: HttpContext): Observable<void> {
    const resp = this.orderControllerGetStats$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `orderControllerGetMyStats()` */
  static readonly OrderControllerGetMyStatsPath = '/api/orders/stats/me';

  /**
   * 내 주문 통계 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerGetMyStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerGetMyStats$Response(params?: OrderControllerGetMyStats$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderMyStatsDto>> {
    const obs = orderControllerGetMyStats(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 내 주문 통계 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerGetMyStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerGetMyStats(params?: OrderControllerGetMyStats$Params, context?: HttpContext): Observable<OrderMyStatsDto> {
    const resp = this.orderControllerGetMyStats$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrderMyStatsDto>): OrderMyStatsDto => r.body)
    );
  }

  /** Path part for operation `orderControllerFindById()` */
  static readonly OrderControllerFindByIdPath = '/api/orders/{id}';

  /**
   * 주문 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerFindById$Response(params: OrderControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderDto>> {
    const obs = orderControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 주문 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerFindById(params: OrderControllerFindById$Params, context?: HttpContext): Observable<OrderDto> {
    const resp = this.orderControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrderDto>): OrderDto => r.body)
    );
  }

  /** Path part for operation `orderControllerConfirmDeposit()` */
  static readonly OrderControllerConfirmDepositPath = '/api/orders/{id}/confirm-deposit';

  /**
   * 입금 확인 처리.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerConfirmDeposit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerConfirmDeposit$Response(params: OrderControllerConfirmDeposit$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderDto>> {
    const obs = orderControllerConfirmDeposit(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 입금 확인 처리.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerConfirmDeposit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerConfirmDeposit(params: OrderControllerConfirmDeposit$Params, context?: HttpContext): Observable<OrderDto> {
    const resp = this.orderControllerConfirmDeposit$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrderDto>): OrderDto => r.body)
    );
  }

  /** Path part for operation `orderControllerCancel()` */
  static readonly OrderControllerCancelPath = '/api/orders/{id}/cancel';

  /**
   * 주문 취소.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerCancel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerCancel$Response(params: OrderControllerCancel$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderDto>> {
    const obs = orderControllerCancel(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 주문 취소.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerCancel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerCancel(params: OrderControllerCancel$Params, context?: HttpContext): Observable<OrderDto> {
    const resp = this.orderControllerCancel$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrderDto>): OrderDto => r.body)
    );
  }

  /** Path part for operation `orderControllerRequestRefund()` */
  static readonly OrderControllerRequestRefundPath = '/api/orders/{id}/request-refund';

  /**
   * 환불 요청 상태 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerRequestRefund()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerRequestRefund$Response(params: OrderControllerRequestRefund$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderDto>> {
    const obs = orderControllerRequestRefund(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 환불 요청 상태 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerRequestRefund$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerRequestRefund(params: OrderControllerRequestRefund$Params, context?: HttpContext): Observable<OrderDto> {
    const resp = this.orderControllerRequestRefund$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrderDto>): OrderDto => r.body)
    );
  }

  /** Path part for operation `orderControllerCompleteRefund()` */
  static readonly OrderControllerCompleteRefundPath = '/api/orders/{id}/complete-refund';

  /**
   * 환불 완료 처리.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerCompleteRefund()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerCompleteRefund$Response(params: OrderControllerCompleteRefund$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderDto>> {
    const obs = orderControllerCompleteRefund(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 환불 완료 처리.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerCompleteRefund$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerCompleteRefund(params: OrderControllerCompleteRefund$Params, context?: HttpContext): Observable<OrderDto> {
    const resp = this.orderControllerCompleteRefund$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrderDto>): OrderDto => r.body)
    );
  }

  /** Path part for operation `orderControllerUpdateMemo()` */
  static readonly OrderControllerUpdateMemoPath = '/api/orders/{id}/memo';

  /**
   * 주문 메모 업데이트.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerUpdateMemo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerUpdateMemo$Response(params: OrderControllerUpdateMemo$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderDto>> {
    const obs = orderControllerUpdateMemo(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 주문 메모 업데이트.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerUpdateMemo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerUpdateMemo(params: OrderControllerUpdateMemo$Params, context?: HttpContext): Observable<OrderDto> {
    const resp = this.orderControllerUpdateMemo$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrderDto>): OrderDto => r.body)
    );
  }

  /** Path part for operation `orderControllerGetRefundAccountByOrder()` */
  static readonly OrderControllerGetRefundAccountByOrderPath = '/api/orders/{id}/refund-account';

  /**
   * 환불계좌 조회 (관리자용).
   *
   * 주문의 회원 환불계좌 정보를 조회합니다. 마스킹 없이 전체 표시됩니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerGetRefundAccountByOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerGetRefundAccountByOrder$Response(params: OrderControllerGetRefundAccountByOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminRefundAccountResponseDto>> {
    const obs = orderControllerGetRefundAccountByOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 환불계좌 조회 (관리자용).
   *
   * 주문의 회원 환불계좌 정보를 조회합니다. 마스킹 없이 전체 표시됩니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerGetRefundAccountByOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerGetRefundAccountByOrder(params: OrderControllerGetRefundAccountByOrder$Params, context?: HttpContext): Observable<AdminRefundAccountResponseDto> {
    const resp = this.orderControllerGetRefundAccountByOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AdminRefundAccountResponseDto>): AdminRefundAccountResponseDto => r.body)
    );
  }

}
